import classNames from "classnames";
import React from "react";
import styles from "./calendarColumn.css";
import { Entry } from "./calendarDay";
import { CurrentTimeIndicator } from "./currentTimeIndicator";

interface Props {
  isToday: boolean;
  className?: string;
  entries: Array<Entry>;
  googleEntries: Array<Entry>;
  children?: Array<JSX.Element>;
  disablePointerEvents?: boolean;
}

const CalendarColumn = (props: Props) => (
  <div className={classNames(styles["calendar-column"], props.className)}>
    <div className={styles["calendar-rows"]}>
      {props.children &&
        props.children.map((child) => (
          <div key={child.key || undefined} className={styles["calendar-row"]}>
            {child}
          </div>
        ))}
      {props.isToday && <CurrentTimeIndicator />}
      {props.googleEntries.map((entry) => (
        <div
          key={entry.element.key || undefined}
          className={classNames(styles["calendar-entry"], {
            [styles["no-pointer-events"]]: props.disablePointerEvents
          })}
          style={{ top: `${entry.offsetFraction * 100}%`, height: `${entry.fillFraction * 100}%` }}
        >
          {entry.element}
        </div>
      ))}
      {props.entries.map((entry) => (
        <div
          key={entry.element.key || undefined}
          className={classNames(styles["calendar-entry"], {
            [styles["no-pointer-events"]]: props.disablePointerEvents
          })}
          style={{ top: `${entry.offsetFraction * 100}%`, height: `${entry.fillFraction * 100}%` }}
        >
          {entry.element}
        </div>
      ))}
    </div>
  </div>
);

export { CalendarColumn };
